export default __webpack_public_path__ + "cda7fcbc4984f49b20403abe6d9a1fb4.png";